import { createContext, useState } from 'react';
import type { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';

export interface PermissionContextValue {
    permission: Array<any>;
    setPermission: (submitting: Array<any>) => void;
    checkPermission: (submitting: string) => any;
}

interface PermissionProviderProps {
    children?: ReactNode;
}

const PermissionContext = createContext<PermissionContextValue>({
    permission: [],
    setPermission: () => { },
    checkPermission: () => { }
});

export const PermissionProvider: FC<PermissionProviderProps> = (props) => {
    const { children } = props;
    const [permission, setPermission] = useState([]);

    const checkPermission = (value) => {
        const isExist = permission.includes(value);
        return isExist;
    };
    return (
        <PermissionContext.Provider
            value={{
                permission,
                setPermission,
                checkPermission
            }}
        >
            {children}
        </PermissionContext.Provider>
    );
};

PermissionProvider.propTypes = {
    children: PropTypes.node.isRequired
};

export const PermissionConsumer = PermissionContext.Consumer;

export default PermissionContext;
